import { createWebSocketStore } from 'src/components/#services/helpers';
export const ligamentsList = createWebSocketStore({
    auth: true,
    requestTemplate: {
        method: 'ligament_getAll',
        agent: 'crypto-market',
        lang: 'en',
        auth: { type: 'webSite' },
    },
});
export const swap = createWebSocketStore({
    auth: true,
    requestTemplate: {
        method: 'swap_swap',
        agent: 'crypto-market',
        lang: 'en',
        auth: { type: 'webSite' },
    },
});
export const swapHistory = createWebSocketStore({
    auth: true,
    requestTemplate: {
        method: 'swap_getAllMy',
        agent: 'crypto-market',
        lang: 'en',
        auth: { type: 'webSite' },
    },
});
